import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.homePage'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: '持有人',
    icon: 'el-icon-s-custom',
    children: [
      {
        title: '持有人',
        route: { name: 'formal_accounts.index' },
        can: ['accounts.read']
      },
      {
        title: '游客',
        route: { name: 'visitor_accounts.index' },
        can: ['accounts.read']
      },
      {
        title: i18n.t('model.user'),
        route: { name: 'users.index' }
      },
    ]
  },
  {
    title: '运营',
    icon: 'el-icon-s-comment',
    children: [
      {
        title: i18n.t('model.riskAssessment'),
        route: { name: 'risk_assessments.index' }
      },
      {
        title: i18n.t('model.riskAssessmentResult'),
        route: { name: 'risk_assessment_results.index' }
      },
      {
        title: i18n.t('model.videoRecord'),
        route: { name: 'video_records.index' }
      },
      {
        title: i18n.t('model.monthlyReport'),
        route: { name: 'monthly_reports.index' }
      },
      {
        title: i18n.t('model.announcement'),
        route: { name: 'announcements.index' }
      },
      {
        title: i18n.t('model.custodianMonthlyReport'),
        route: { name: 'custodian_monthly_reports.index' }
      },
    ]
  },
  {
    title: '基金',
    icon: 'el-icon-s-marketing',
    children: [
      {
        title: i18n.t('model.fund'),
        route: { name: 'funds.index' }
      },
      {
        title: i18n.t('model.fundValue'),
        route: { name: 'fund_values.index', query: { 'order[date]': 'desc' } }
      },
      {
        title: i18n.t('model.trade'),
        route: { name: 'trades.index' }
      },
      {
        title: i18n.t('model.tradeApplyRecord'),
        route: { name: 'trade_apply_records.index' }
      },
      {
        title: i18n.t('menu.achievementPayCompute'),
        route: { name: 'achievement_pay_compute' },
        can: ['trades.read']
      },
      {
        title: i18n.t('menu.singleAchievementPayCompute'),
        route: { name: 'single_achievement_pay_compute' },
        can: ['trades.read']
      },
    ]
  },
  {
    title: '设置',
    icon: 'el-icon-setting',
    children: [
      {
        title: i18n.t('model.tradeRule'),
        route: { name: 'trade_rules.index' }
      },
      {
        title: i18n.t('model.page'),
        route: { name: 'pages.index' }
      },
      {
        title: i18n.t('model.application'),
        route: { name: 'applications.show', params: { id: 'current' } },
        can: ['applications.read_detail_menu']
      },
      {
        title: i18n.t('model.adminUsersRole'),
        route: { name: 'admin_users_roles.index' }
      },
      {
        title: i18n.t('model.role'),
        route: { name: 'roles.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.dataAnalysis'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('wechatMiniProgram.analysis.userPortrait'),
        route: { name: 'user_portrait' },
        can: 'data_analyses.user_portrait'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitPage'),
        route: { name: 'visit_page' },
        can: 'data_analyses.visit_page'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitDistribution'),
        route: { name: 'visit_distribution' },
        can: 'data_analyses.visit_distribution'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitRetain'),
        route: { name: 'retain_info' },
        can: 'data_analyses.retain_info'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitTrend'),
        route: { name: 'visit_trend' },
        can: 'data_analyses.visit_trend'
      }
    ]
  },
  // 以下代码为generator插入代码的标记，请勿修改或删除
  // Generator menu
];
